import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import NotificationContextProvider from './NotificationContextProvider';

import enMessages from "./localization/en.json";
// Waiting full french translation import frFrameworkMessages from "devextreme/localization/messages/fr.json";
// Waiting full french translation import frMessages from "./localization/fr.json";

import { locale, loadMessages } from "devextreme/localization";

function App() {
    const { user, loading } = useAuth();

    loadMessages(enMessages);
    // Waiting full french translation loadMessages(frFrameworkMessages);
    // Waiting full french translation loadMessages(frMessages);

    locale(navigator.language);

    if (loading) {
        return <LoadPanel visible={true} />;
    }

    if (user) {
        return <NotificationContextProvider currentUserData={user}><Content /></NotificationContextProvider>;
    }

    return <UnauthenticatedContent />;
}

export default function Root() {
    const screenSizeClass = useScreenSizeClass();

    return (
        <Router>
            <AuthProvider>
                <NavigationProvider>
                    <div className={`app ${screenSizeClass} dx-theme-background-color`}>
                        <App />
                    </div>
                </NavigationProvider>
            </AuthProvider>
        </Router>
    );
}
